import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import FlexRow from "../../../components/base/FlexRow";
import ScrollContainer from "../../../components/base/ScrollContainer";
import Section from "../../../components/base/Section";
import Layout from "../../../components/layouts/Layout";
import AccountsSideMenu, { useAccountsSideMenuItems } from "./AccountsSideMenu";
import { clearPageName, useScreen } from "../../../core/Global";
import PageTitleBar from "../../../components/layouts/header/PageTitleBar";
import { getFirstAccessibleLink, useModuleLastPage } from "../../../components/layouts/aside/useModuleLastPage";
import ModuleSidebar from "../../../components/layouts/aside/ModuleSidebar";


export default function AccountsMainView() {

    const screen = useScreen()
    const location = useLocation()
    const sideMenuItems = useAccountsSideMenuItems()
    const defaultLink = getFirstAccessibleLink(sideMenuItems, "/accounts/admins") ?? "/accounts/admins"
    useModuleLastPage("/accounts", defaultLink)

    useEffect(() => {
        return () => {
            clearPageName()
        }
    }, [location.pathname])

    return (
        <Layout wide noToolbar paddingBottom={0} paddingTop={0}>
            <Section fluid fit>
                <FlexRow alignItems="start">

                    {
                        !screen.isMobile &&
                        <ModuleSidebar storageKey="rinvox-sidebar-collapsed-accounts">
                            <AccountsSideMenu />
                        </ModuleSidebar>
                    }

                    <div className="flex-row-fluid">

                        <PageTitleBar />

                        <ScrollContainer>
                            <Outlet />
                        </ScrollContainer>

                    </div>

                </FlexRow>
            </Section>
        </Layout>
    )
}
